import { IonContent, IonFooter, IonHeader, IonModal } from '@ionic/react'
import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { cartMobx, discountMobx } from '@mobx/mall'
import { format } from '@dt/fe-utils'
import { forEach } from '@dt/fe-utils/dist/lodash'
import './index.scss'

const ActivityModal: React.FC<any> = (props) => {
  const { cartResult } = cartMobx
  const { discountResult } = discountMobx
  const [activityItemObj, setActivityItemObj] = useState({})
  const handleClose = () => {
    props.reject()
  }

  const ActivityItem = (item: any) => (
    <div className='am-item'>
      <div className='name'>{item.offTip}</div>
      <div className='used-discount'>-{format.toPrice(item.off)}</div>
    </div>
  )

  const initItem = () => {
    // 整单优惠
    discountResult.offArr.forEach(item => {
      if (['activity', 'ladderDiscount'].includes(item.offType)) {
        if (activityItemObj[item.offId]) {
          activityItemObj[item.offId].off += item.off
        } else {
          activityItemObj[item.offId] = { offTip: item.offTip, off: item.off, offId: item.offId }
        }
      }
    })
    forEach(discountResult.itemMap, itemDiscount => itemDiscount.items && itemDiscount.items.forEach(item => {
      if (['activity', 'ladderDiscount'].includes(item.offType)) {
        if (activityItemObj[item.offId]) {
          activityItemObj[item.offId].off += item.off
        } else {
          activityItemObj[item.offId] = { offTip: item.offTip, off: item.off, offId: item.offId }
        }
      }
    }))
    setActivityItemObj({ ...activityItemObj })
  }

  useEffect(() => {
    initItem()
  }, [discountResult])

  return (
    <IonModal
      cssClass='mall-activity-modal'
      isOpen
      showBackdrop
      swipeToClose
      backdropDismiss={false}
    >
      <IonHeader>
        <div className='am-title'>{i18n.t('cart.discountActivity')}</div>
      </IonHeader>
      <IonContent className='am-content'>
        <div className='am-list'>
          {
            Object.values(activityItemObj).map((itemDiscount: any) => {
              return <ActivityItem key={itemDiscount.offId} {...itemDiscount} />
            })
          }
        </div>
        <div className='am-result'>
          {i18n.t('cart.discountPriceTotal')} <span>-{format.toPrice(cartResult.activityPrice)}</span>
        </div>
      </IonContent>
      <IonFooter className='am-footer'>
        <button className='default-btn' onClick={handleClose}>
          {i18n.t('common.back')}
        </button>
      </IonFooter>
    </IonModal>
  )
}

export default observer(ActivityModal)
